import { createContext, useContext } from "react";
const VersionContext = createContext("modern");
function useVersionContext() {
  const context = useContext(VersionContext);
  return context || "modern";
}
export {
  VersionContext,
  useVersionContext
};
//# sourceMappingURL=versionContext.js.map
